import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  contentTooltip: {
    maxWidth: "80vw",
    "& *": {
      background: "none !important"
    }
  },
}));

export default useStyle;